export const CLOUD_DOMAIN = 'd2lomvz2jrw9ac.cloudfront.net';
